import React, { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { GlobalStyles } from "@mui/joy";
import Settings from "components/common/Settings";
import LoginHintReceiver from "components/common/LoginHintReceiver";
import useIsInappWebview from "hooks/useIsInappWebview";
import { pcTabFromPath } from "recoil/pcSideTabAtom";
import { BUILD_TARGET } from "config";
import "translation/i18n";

export default function RootLayout() {
  const handleResize = () => {
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty("--vh", `${vh}px`);
  };

  useEffect(() => {
    var useragt = navigator.userAgent.toLowerCase();
    var target_url = window.location.href;

    if (useragt.match(/kakaotalk/i)) {
      //카카오톡 외부브라우저로 호출
      window.location.href =
        "kakaotalk://web/openExternal?url=" + encodeURIComponent(target_url);
      setTimeout(() => {
        var mobile = document.createElement("meta");
        mobile.name = "viewport";
        mobile.content =
          "width=device-width, initial-scale=1, shrink-to-fit=no, user-scalable=no, minimal-ui";
        document.getElementsByTagName("head")[0].appendChild(mobile);
        document.body.innerHTML = `
        <style>body{background-color:#EEF2F3; margin:0; padding:0; overflow:hidden; width:100%; height: 100%; display:flex; justify-content:center; align-items:center}</style>
        <div style='display:flex; justify-content:center'>
        <svg
        width='256'
        height='256'
        viewBox='0 0 256 256'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M40 56H120V72H200V88H248V168H200V200H184L152 168H120H40V56ZM40 168H8V88H40V168Z'
          fill='#E2E6E8'
        />
      </svg></div>`;
      }, 100);
    } else if (useragt.match(/line/i)) {
      //라인 외부브라우저로 호출
      if (target_url.indexOf("?") !== -1) {
        window.location.href = target_url + "&openExternalBrowser=1";
      } else {
        window.location.href = target_url + "?openExternalBrowser=1";
      }
    } else if (
      useragt.match(
        /inapp|naver|snapchat|wirtschaftswoche|thunderbird|instagram|everytimeapp|whatsApp|electron|wadiz|aliapp|zumapp|iphone(.*)whale|android(.*)whale|kakaostory|band|twitter|DaumApps|DaumDevice\/mobile|FB_IAB|FB4A|FBAN|FBIOS|FBSS|trill|SamsungBrowser\/[^1]/i
      )
    ) {
    }

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const isDev = BUILD_TARGET === "dev";

  if (!isDev) {
    // 리얼에서 사용할 수 없도록
    var console = window.console || {};
    console.log = function no_console() {}; // console log 막기
    console.warn = function no_console() {}; // console warning 막기
    console.error = function () {}; // console error 막기
  }
  // --Sidebar-width 는 실제 렌더되는 사이드바(SideBarLayoutForPatient 가 URL 의
  // pcTabFromPath 로 판단)와 일치해야 한다. 아톰(기본 "home")을 쓰면 deep-link/새로고침
  // 시 mypage 경로인데도 320px 로 잡혀 fixed 영역(FloatingArea 등)이 우측으로 밀린다.
  const location = useLocation();
  const pcTab = pcTabFromPath(location.pathname);
  const isInappWebview = useIsInappWebview();

  const sidebarWidth = isInappWebview
    ? `${window.innerWidth}px`
    : pcTab === "home"
      ? "320px"
      : "0px";
  const pcSideTabWidth = isInappWebview ? "0px" : "60px";

  return (
    <div
      className="w-screen h-screen flex flex-col "
      style={{
        height: "calc(var(--vh,1vh) * 100)",
        minHeight: "calc(var(--vh,1vh) * 100)",
        whiteSpace: "pre-line",
        ...(isInappWebview && {
          "-webkit-user-select": "none" /* Safari, Chrome */,
          "-moz-user-select": "none" /* Firefox */,
          "-ms-user-select": "none" /* IE/Edge */,
          "user-select": "none",
        }),
      }}
    >
      <GlobalStyles
        styles={(theme) => ({
          ":root": {
            "--Sidebar-width": sidebarWidth,
            "--StickyHeader-height": "60px",
            "--InsideC-width": isInappWebview
              ? `${window.innerWidth}px`
              : "380px",
            "--PC-SideTab-width": pcSideTabWidth,
          },
        })}
      />
      <LoginHintReceiver />
      <Settings>
        <div className="flex-1 flex  overflow-hidden">
          <Outlet />
        </div>
      </Settings>
    </div>
  );
}
